module.exports = __webpack_public_path__ + "downloads/YKBResume.27ed7f07.pdf";